import Vue from 'vue'

export default Vue.component(
  'accordion',
  {
    props: ['accordionId'],
    data () {
      return {
        activeItem: -1
      }
    },
    methods: {
      toggleItem (itemNumber) {
        if (itemNumber === this.activeItem) {
          this.collapseItem(itemNumber)
        } else {
          if (this.activeItem !== -1) {
            this.collapseItem(this.activeItem)
          }
          this.expandItem(itemNumber)
        }
      },

      /*
       * Approach stolen/adapted from:
       * https://css-tricks.com/using-css-transitions-auto-dimensions/#technique-3-javascript
       */
      expandItem (itemNumber) {
        // Get  height of the element's inner content
        var element = document.getElementById('v-accordion-' + this.accordionId + '__container--' + itemNumber)
        var inner = document.getElementById('v-accordion-' + this.accordionId + '__content--' + itemNumber)
        var sectionHeight = inner.scrollHeight

        // Have the container transition to the height of its inner content
        element.style.height = sectionHeight + 'px'

        const removeFixedHeightStyle = function (e) {
          // Remove this listener so it only gets triggered once
          element.removeEventListener('transitionend', removeFixedHeightStyle)

          // Set height to auto once expanded to handle screen resizing etc.
          element.style.height = 'auto'
        }

        // When the next CSS transition finishes (which should be the one we just triggered)
        element.addEventListener('transitionend', removeFixedHeightStyle)

        // Set active item number
        this.activeItem = itemNumber
      },
      collapseItem (itemNumber) {
        // Get  height of the element's inner content
        var element = document.getElementById('v-accordion-' + this.accordionId + '__container--' + itemNumber)
        var inner = document.getElementById('v-accordion-' + this.accordionId + '__content--' + itemNumber)
        var sectionHeight = inner.scrollHeight

        // Temporarily disable all CSS transitions
        var elementTransition = element.style.transition
        element.style.transition = ''

        /*
         * On the next frame (as soon as the previous style change has taken effect),
         * explicitly set the element's height to its current pixel height, so we
         * aren't transitioning out of 'auto'
         */
        requestAnimationFrame(function () { // eslint-disable-line
          element.style.height = sectionHeight + 'px'
          element.style.transition = elementTransition

          /*
           * On the next frame (as soon as the previous style change has taken effect),
           * have the element transition to height: 0
           */
          requestAnimationFrame(function () { // eslint-disable-line
            element.style.height = 0 + 'px'
          })
        })

        // Reset active item number
        this.activeItem = -1
      }
    }
  }
)
